import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import './Footer.css';
import { CONTACT_INFO } from '../constants';

function Footer() {
  useEffect(() => {
    // Reload Trustpilot widget when component mounts
    if (window.Trustpilot) {
      const trustbox = document.getElementById('trustpilot-widget');
      if (trustbox) {
        window.Trustpilot.loadFromElement(trustbox);
      }
    }
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>BookMyNewsAd</h3>
          <p>Your trusted partner for booking newspaper advertisements online at the lowest rates.</p>
          
          {/* Trustpilot Widget */}
          <div 
            id="trustpilot-widget"
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id="56278e9abfbbba0bdcd568bc"
            data-businessunit-id="6957d7a15fb698cf3a93af72"
            data-style-height="52px"
            data-style-width="100%"
            data-token="9aa55957-39aa-4aec-8dfa-f0106c778a17"
          >
            <a href="https://www.trustpilot.com/review/bookmynewsad.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/samples">Ad Samples</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
        
        {/* <div className="footer-section">
          <h4>Services</h4>
          <p>Matrimonial Ads</p>
          <p>Public Notice</p>
          <p>Recruitment Ads</p>
          <p>Property Ads</p>
        </div> */}
        
        <div className="footer-section">
          <h4>Regional Ads</h4>
          <Link to="/ads/english">English Ads</Link>
          <Link to="/ads/hindi">Hindi Ads</Link>
          <Link to="/ads/kannada">Kannada Ads</Link>
          <Link to="/ads/marathi">Marathi Ads</Link>
          <Link to="/ads/tamil">Tamil Ads</Link>
          <Link to="/ads/malayalam">Malayalam Ads</Link>
          <Link to="/ads/bengali">Bengali Ads</Link>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <p>
            📞 <a href={`tel:${CONTACT_INFO.PHONE.VALUE}`} className="footer-contact-link">{CONTACT_INFO.PHONE.DISPLAY}</a>
          </p>
          <p>
            ✉️ <a href={`mailto:${CONTACT_INFO.EMAIL}`} className="footer-contact-link">{CONTACT_INFO.EMAIL}</a>
          </p>
          <p>📍 {CONTACT_INFO.ADDRESS.CITY}</p>
          <div className="footer-social-links">
            <a href={CONTACT_INFO.SOCIAL.FACEBOOK} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href={CONTACT_INFO.SOCIAL.INSTAGRAM} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href={CONTACT_INFO.SOCIAL.TWITTER} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href={CONTACT_INFO.SOCIAL.LINKEDIN} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 BookMyNewsAd. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
